/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Input, Row, Col, FormFeedback } from 'reactstrap'

import CreatableSelect from 'react-select'
import Select from 'react-select'

import {AppContext} from '../../AppContext';

class CharacterKeywordValue extends React.Component
{

  inputKeywordValue = undefined;
  keywordValue = null;

  constructor(props)
  {
    super();

    this.state =
    {
      suggestedValues: [],
      keywordValue: (undefined === props.keywordAndValue.characterValue ? '' : props.keywordAndValue.characterValue)
    }

    this.selectChangeHandler = this.selectChangeHandler.bind(this);
    this.inputChangeHandler = this.inputChangeHandler.bind(this);
    this.creatableInputChange = this.creatableInputChange.bind(this);
    this.creatableChange = this.creatableChange.bind(this);
  }

  componentDidMount()
  {
    if ('dynamic list' === this.props.keywordAndValue.userInputHandling || 'static list' === this.props.keywordAndValue.userInputHandling)
    {
      this.fetchSuggestedValues();
    }
  }

  creatableChange(value, actionMetaD)
  {
    if ('select-option' === actionMetaD.action)
    {
      this.setState({keywordValue: value.keywordValue});
      this.props.setSaveButtonDisabled(false);
      this.props.setKeywordValue(value.keywordValue);      
      return;
    }
  }

  creatableInputChange(value, actionMetaData)
  {
    if ('create-option' === actionMetaData.action)
    {
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.setState({keywordValue: value.keywordValue});
      this.props.setKeywordValue(value.keywordValue);
      return;
    }

    if ('select-option' === actionMetaData.action)
    {
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.setState({keywordValue: value.keywordValue});
      this.props.setKeywordValue(value.keywordValue);      
      return;
    }

    if ('input-change' === actionMetaData.action)
    {
      this.inputKeywordValue = value;
      this.props.setSaveButtonDisabled(undefined === value ? true : false);
      this.setState({keywordValue: this.inputKeywordValue});
      return;
    }

    if ('menu-close' === actionMetaData.action)
    {
      if ('' === value && undefined !== this.inputKeywordValue)
      {
        this.props.setSaveButtonDisabled(false);
        this.setState({keywordValue: this.inputKeywordValue});
        this.props.setKeywordValue(this.inputKeywordValue);
        this.inputKeywordValue = undefined;
        return;
      }
    }
  }

  async fetchSuggestedValues()
  {
    let bodyData = {keywordId: this.props.keywordAndValue.keywordId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSuggestions', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error loading keyword value suggestions');    
    this.setState({suggestedValues: result.jsonData.suggestedValues})
  }

  inputChangeHandler(event)
  {
    this.props.setSaveButtonDisabled('' === event.target.value ? true : false);
    this.setState({keywordValue: event.target.value});
    this.props.setKeywordValue(event.target.value);
  }

  isValidNewOption(inputValue, selectValue, selectOptions)
  {
    return true;
  }

  render()
  {
    if ('dynamic list' === this.props.keywordAndValue.userInputHandling)
    {
      let formFeedback = null;

      if (!this.props.validValue)
        formFeedback = (
          <div style={{color: 'red'}}>
            <Row><Col>You must select a value...!!!</Col></Row>
          </div>
        );

      const components = 
      {
        DropdownIndicator: null,
      };

      return(
        <div>
          <Row><Col>Select an existing value or input a new value.</Col></Row>
          <Row style={{paddingTop: '10px'}}>
            <Col>
              <CreatableSelect options={this.state.suggestedValues} value={{keywordValue: this.state.keywordValue}}
                getOptionLabel={option => option.keywordValue} getOptionValue={option => option.keywordValue} autoFocus
                getNewOptionData={(inputValue, optionLabel) => (
                  {
                    keywordValue: inputValue
                  })}
                isValidNewOption={this.isValidNewOption}
                onChange={this.creatableChange}
                onInputChange={this.creatableInputChange}
                components={components}
              />
            </Col>
          </Row>
          {formFeedback}
        </div>
      );
    }

    if ('static list' === this.props.keywordAndValue.userInputHandling)
    {
      let formFeedback = null;

      if (!this.props.validValue)
        formFeedback = (
          <div style={{color: 'red'}}>
            <Row><Col>You must select a value...!!!</Col></Row>
          </div>
        );

      return(
        <div>
          <Row><Col>Select an existing value.</Col></Row>
          <Row style={{paddingTop: '10px'}}>
            <Col>
              <Select value={{keywordValue: this.state.keywordValue}} options={this.state.suggestedValues} 
                getOptionLabel={option => option.keywordValue} getOptionValue={option => option.keywordValue} autoFocus simpleValue={true} 
                clearValueText="Clear" placeholder="Select a value..." noResultsText="No suggested values found"
                onChange={this.selectChangeHandler} />
            </Col>
          </Row>
          {formFeedback}
        </div>
      );
    }

    if ('no suggestions' === this.props.keywordAndValue.userInputHandling)
    {
      return(
        <div>
          <Row><Col>Edit the keyword value.</Col></Row>
          <Row style={{paddingTop: '10px'}}>
            <Col>
              <Input type="text" placeholder="Provide a value..." autoFocus
                value={this.state.keywordValue} invalid={!this.props.validValue} valid={this.props.validValue}
                onChange={this.inputChangeHandler} />
              <FormFeedback valid={false}>You must provide a value.</FormFeedback>
            </Col>
          </Row>
        </div>
      )
    }

    return (<div><p>This keyword is not setup properly to allow user input or offer suggested values.</p></div>);
  }

  selectChangeHandler(value, actionMetaD)
  {
    this.props.setSaveButtonDisabled(undefined === value ? true : false);
    this.setState({keywordValue: value.keywordValue});
    this.props.setKeywordValue(value.keywordValue);
  }

  selectCreateOptionText(optionValue)
  {
    return 'Create value "' + optionValue + '"';
  }
}

CharacterKeywordValue.contextType = AppContext;

export default CharacterKeywordValue